const AnalysisStudyUserContextParams = {
  oneoff: {
    paramType: "enum",
    validEnumValues: ["true", "false", "only"],
    storeParamName: "showOneOff",
    defaultValue: "true"
  },
  disabled: {
    paramType: "enum",
    validEnumValues: ["true", "false", "only"],
    storeParamName: "showDisabled",
    defaultValue: "true"
  },
  retroaa: {
    paramType: "enum",
    validEnumValues: ["true", "false", "only"],
    storeParamName: "showRetroAA",
    defaultValue: "true"
  },
  showProps: {
    paramType: "enum",
    validEnumValues: [
      "datarange",
      "flights",
      "datasource",
      "analysistype",
      "vertical",
      "template",
      "markets",
      "resources",
      "references",
      "isUtc",
      "filter"
    ],
    storeParamName: "showAdditionalProps",
    isMultiValue: true
  },
  showFilterTypes: {
    paramType: "enum",
    validEnumValues: ["triggerFilter", "sessionTrigger", "filter"],
    isMultiValue: true
  },
  filter: { paramType: "string" },
  highlight: { paramType: "string" },
  scorecardId: { paramType: "string" }
};
export {
  AnalysisStudyUserContextParams
};
//# sourceMappingURL=AnalysisStudyUserContextParams.js.map
